export default function MySQL_LOWER() {
  return (
    <div>
      <h2>MySQL_LOWER</h2>    </div>
  );
}